module.exports = __webpack_public_path__ + "img/phone.dd6e352b.svg";